import React, {useEffect, useState} from 'react';
import axios from "axios";
import { Autoplay } from "swiper";
import {Swiper, SwiperSlide,useSwiper} from "swiper/react";
import './BrandFocusSlider.css'


const BrandSlider = () => {
    const [swiper, setSwiper] = useState(null);
    const [brands, setBrands] = useState([]);
    useEffect(() => {
        const fetchBrands = async () => {
            try {
                const res = await axios.get(process.env.REACT_APP_BASE_URL + "/getBrands");
                if (res.status === 200) {
                    setBrands(res.data);
                }
            } catch (error) {
                console.error("Error fetching brands:", error);
            } finally {
            }
        };

        fetchBrands();
    }, []);
    useEffect(()=>{
        if(swiper){
            console.log(swiper)
            swiper?.autoplay?.start();
        }
    },[swiper])
    return <div className={'brand-focus-slider'}
                tabIndex={1}
                role="button"
                onMouseEnter={() => swiper?.autoplay?.stop()}
                onMouseLeave={() => swiper?.autoplay?.start()}
    >
        <Swiper
            id={'brand-focus-slider'}
            onSwiper={setSwiper}
            autoplay={{
                pauseOnMouseEnter: true,
                delay: 0,
                disableOnInteraction: false,
            }}
            spaceBetween={0}
            speed={3000}
            direction={'horizontal'}
            slidesPerView={2}
            freeMode={true}

            modules={[Autoplay]}
            loop={true}
            breakpoints={{
                480: {slidesPerView: 3},
                640: {slidesPerView: 3},
                768: {slidesPerView: 4},
                1024: {slidesPerView: 6},
                1280: {slidesPerView: 7},
            }}
            className="!px-0"
        >
            {brands.map((logo ) => (
                <SwiperSlide key={logo.brand}>


                    <a
                        href={`/brands/${logo.slug}`}
                        aria-label={logo.brand}
                        className="group w-full p-1 sm:p-3 lg:p-4 flex items-center justify-center"
                    >
                        <div
                            className="footer-brand-image w-full min-h-[5.75rem] h-auto sm:h-14 sm:min-h-0 md:h-20 lg:h-28 xl:h-32 flex items-center justify-center bg-gray-50 rounded-md overflow-visible sm:overflow-hidden shadow-none sm:shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl py-2.5 px-1 sm:py-0 sm:px-0"
                        >
                            <img
                                src={logo.brandImage}
                                alt={logo.brand}
                                className={`mx-auto object-contain max-h-[4.75rem] sm:max-h-10 md:max-h-14 lg:max-h-20 xl:max-h-24 max-w-[96%] sm:max-w-full h-auto ${logo.brand === 'EA7' ? 'resize-brand' : ''}`}
                                loading="lazy"
                                width="200"
                                height="80"
                            />
                        </div>
                    </a>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
}

export default BrandSlider;